module.exports = __webpack_public_path__ + "static/media/best-seller.b50acaf5.png";